/**
 * Reads the operator-configured sub-batch size from localStorage.
 * Falls back to `defaultValue` when the key is absent or invalid.
 * Used by product-selection page (content-scoring trigger) and the adapter
 * (sample + pipeline triggers) to honour the persisted batch preference.
 */
export function getSubBatchSize(defaultValue: number): number {
  try {
    const raw = localStorage.getItem('subBatchSize');
    if (raw === null) return defaultValue;
    const parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : defaultValue;
  } catch {
    return defaultValue;
  }
}
